import React from 'react';
import { Phone, CheckCircle, Wrench, Info } from 'lucide-react';
export function LiftgateInfoPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4329">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4330">
        <div className="container mx-auto px-4" data-id="element-4331">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4332">
            LIFTGATE SERVICE
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4333">
            Complete Sales, Service & Maintenance
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4334">
        <div className="max-w-4xl mx-auto" data-id="element-4335">
          {/* Conventional Liftgates */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4336">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4337">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4338" />
              Conventional Liftgates
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4339">
              <p className="text-gray-700 flex items-start" data-id="element-4340">
                <Info className="mr-3 flex-shrink-0 mt-1 text-blue-600" size={20} data-id="element-4341" />
                <span data-id="element-4342">
                  These are the first type of liftgate design invented
                </span>
              </p>
            </div>

            <div className="space-y-4" data-id="element-4343">
              <div className="flex items-start" data-id="element-4344">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4345" />
                <p className="text-gray-700" data-id="element-4346">
                  Mount to the chassis frame of a truck or trailer (usually a
                  straight truck)
                </p>
              </div>

              <div className="flex items-start" data-id="element-4347">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4348" />
                <p className="text-gray-700" data-id="element-4349">
                  Store in a position against the rear doorway
                </p>
              </div>

              <div className="flex items-start" data-id="element-4350">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4351" />
                <p className="text-gray-700" data-id="element-4352">
                  Often used on stake bed trucks to provide a lifting device and
                  a tailgate at the same time
                </p>
              </div>

              <div className="flex items-start" data-id="element-4353">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4354" />
                <p className="text-gray-700" data-id="element-4355">
                  Platforms are generally of the 'ramp ride' design
                </p>
              </div>

              <div className="flex items-start" data-id="element-4356">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4357" />
                <p className="text-gray-700" data-id="element-4358">
                  A level ride can be provided although special consideration
                  must be given to accomplish a ramp that will touch the ground
                  if needed
                </p>
              </div>

              <div className="flex items-start" data-id="element-4359">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4360" />
                <p className="text-gray-700" data-id="element-4361">
                  A pivoting ramp (such as an aluminum retention ramp) can be
                  considered for ground contact
                </p>
              </div>
            </div>
          </div>

          {/* Pickup Truck Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4362">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4363">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4364" />
              Pickup Truck Models
            </h2>

            <div className="space-y-4" data-id="element-4365">
              <div className="flex items-start" data-id="element-4366">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4367" />
                <p className="text-gray-700" data-id="element-4368">
                  Typically mounted on pickup trucks
                </p>
              </div>

              <div className="flex items-start" data-id="element-4369">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4370" />
                <p className="text-gray-700" data-id="element-4371">
                  Same design is often modified (made wider with higher truck
                  floor ability) to be used on high cube vans, stake beds and
                  utility bodies
                </p>
              </div>

              <div className="flex items-start" data-id="element-4372">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4373" />
                <p className="text-gray-700" data-id="element-4374">
                  Platforms fold up vertically in the stored position as a
                  tailgate
                </p>
              </div>

              <div className="flex items-start" data-id="element-4375">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4376" />
                <p className="text-gray-700" data-id="element-4377">
                  Basically a 'level ride' design like RailTrac models but move
                  in an arching movement as do TuckUnders and Conventionals
                </p>
              </div>

              <div className="flex items-start" data-id="element-4378">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4379" />
                <p className="text-gray-700" data-id="element-4380">
                  Normally mounted to the truck vertical posts and the truck bed
                  rear edge
                </p>
              </div>

              <div className="flex items-start" data-id="element-4381">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4382" />
                <p className="text-gray-700" data-id="element-4383">
                  On stake truck beds a gusset is often used and attached to the
                  truck floor sides to create a corner post reinforcement for
                  the liftgate
                </p>
              </div>
            </div>
          </div>

          {/* FLIPAWAY / TuckUnder Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4384">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4385">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-4386" />
              FLIPAWAY / TuckUnder Models
            </h2>

            <div className="space-y-4" data-id="element-4387">
              <div className="flex items-start" data-id="element-4388">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4389" />
                <p className="text-gray-700" data-id="element-4390">
                  Mount to the chassis frame of a truck or trailer
                </p>
              </div>

              <div className="flex items-start" data-id="element-4391">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4392" />
                <p className="text-gray-700" data-id="element-4393">
                  Tuck and store underneath the rear of the truck or trailer
                </p>
              </div>

              <div className="flex items-start" data-id="element-4394">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4395" />
                <p className="text-gray-700" data-id="element-4396">
                  In the stored or tucked position they provide unobstructed
                  access to the truck or trailer doorway
                </p>
              </div>

              <div className="flex items-start" data-id="element-4397">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4398" />
                <p className="text-gray-700" data-id="element-4399">
                  Typically a 'ramp ride' design but may be specified as a
                  'level ride' for certain models and applications
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mt-6" data-id="element-4400">
              <h3 className="font-bold text-gray-900 mb-3" data-id="element-4401">
                Design Types Explained:
              </h3>

              <div className="space-y-3" data-id="element-4402">
                <div data-id="element-4403">
                  <p className="font-semibold text-gray-900" data-id="element-4404">Ramp Ride:</p>
                  <p className="text-gray-700" data-id="element-4405">
                    The platform is basically level at the truck floor position
                    and it then ramps down gradually as it approaches and then
                    touches the ground. The ramp edge is therefore touching the
                    ground at that point.
                  </p>
                </div>

                <div data-id="element-4406">
                  <p className="font-semibold text-gray-900" data-id="element-4407">Level Ride:</p>
                  <p className="text-gray-700" data-id="element-4408">
                    TuckUnder platform ramp edge may not touch the ground at the
                    fully lowered position and may need a pivoting ramp in order
                    to touch the ground.
                  </p>
                </div>

                <div data-id="element-4409">
                  <p className="font-semibold text-gray-900" data-id="element-4410">Movement:</p>
                  <p className="text-gray-700" data-id="element-4411">
                    The platform moves in an arch from the truck floor to the
                    ground and the ground to the truck floor.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Services Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4412">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4413">
              Complete Liftgate Services
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-4414">
              <div className="text-center" data-id="element-4415">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4416">
                  <Wrench className="text-blue-600" size={32} data-id="element-4417" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4418">Sales</h3>
                <p className="text-gray-700" data-id="element-4419">
                  All liftgate types and models for your commercial needs
                </p>
              </div>

              <div className="text-center" data-id="element-4420">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4421">
                  <CheckCircle className="text-green-600" size={32} data-id="element-4422" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4423">
                  Service
                </h3>
                <p className="text-gray-700" data-id="element-4424">
                  Expert repair and service for all liftgate systems
                </p>
              </div>

              <div className="text-center" data-id="element-4425">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4426">
                  <Info className="text-purple-600" size={32} data-id="element-4427" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4428">
                  Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-4429">
                  Preventative maintenance to keep your liftgate operating
                  smoothly
                </p>
              </div>
            </div>
          </div>

          {/* Liftgate Types Summary */}
          <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg shadow-md p-8 mb-8" data-id="element-4430">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4431">
              Liftgate Types We Service
            </h2>

            <div className="grid md:grid-cols-3 gap-4" data-id="element-4432">
              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4433">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4434">Conventional</h3>
                <p className="text-sm text-gray-700" data-id="element-4435">
                  First design invented, mounts to chassis frame, stores against
                  rear doorway
                </p>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4436">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4437">Pickup Truck</h3>
                <p className="text-sm text-gray-700" data-id="element-4438">
                  Vertical fold-up design, level ride with arching movement
                </p>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-4439">
                <h3 className="font-bold text-[#B1050B] mb-2" data-id="element-4440">
                  FLIPAWAY / TuckUnder
                </h3>
                <p className="text-sm text-gray-700" data-id="element-4441">
                  Stores underneath, unobstructed doorway access
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4442">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4443">
              Expert Liftgate Sales, Service & Maintenance
            </h2>
            <p className="text-xl mb-6" data-id="element-4444">
              Complete solutions for all liftgate types and models
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4445">
              <Phone className="mr-3" size={24} data-id="element-4446" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4447">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}